var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.06606 2.19223C7.18717 1.92309 7.45487 1.75 7.75 1.75H8.25C9.49264 1.75 10.5 2.75736 10.5 4V6.25H13.3456C14.5486 6.25 15.3929 7.43567 14.9994 8.57244L13.4417 13.0724C13.1977 13.7773 12.5338 14.25 11.7879 14.25H3.25C2.55964 14.25 2 13.6904 2 13V8C2 7.30964 2.55964 6.75 3.25 6.75H5.01506L7.06606 2.19223ZM4.75 8.25H3.5V12.75H4.75V8.25ZM6.25 12.75H11.7879C11.8945 12.75 11.9893 12.6825 12.0242 12.5818L13.5819 8.08178C13.6381 7.91938 13.5175 7.75 13.3456 7.75H9.75C9.33579 7.75 9 7.41421 9 7V4C9 3.58579 8.66421 3.25 8.25 3.25H8.23494L6.25 7.66098V12.75Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUp);
export default ForwardRef;